import { mapDTO } from '@twistezo/ts-dto-mapper'

import { DomainRichPlacementMultiAnchor } from '../../types/domainRichPlacementMultiAnchor'
import { DomainRichPlacementMultiAnchorConfigurationDTO } from '../types/domainRichPlacementMultianchorConfigurationDTO'

type From = DomainRichPlacementMultiAnchorConfigurationDTO
type To = DomainRichPlacementMultiAnchor

export const domainRichPlacementMultiAnchorFromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((data: From): To => {
    const {
      customizeApperanceEnabled,
      customizeBasicSettingsEnabled,
      customStyling,
      displayAfterUserInteractionEnabled,
      enabled,
      fullWidthModeEnabled,
      showCloseButtonEnabled,
      singleAdViewTime,
    } = data

    return {
      customizeAppearance: customizeApperanceEnabled,
      customizeBasicSettings: customizeBasicSettingsEnabled,
      customStyling: customStyling ?? '',
      displayAfterUserInteraction: displayAfterUserInteractionEnabled,
      enabled,
      fullWidthMode: fullWidthModeEnabled,
      showCloseButton: showCloseButtonEnabled,
      singleAdViewTime,
    }
  })
